/*jslint       browser: true, continue: true,
 devel: true, indent: 2, maxerr: 50,
 newcap: true, nomen: true, plusplus: true,
 regexp: true, sloppy: true, vars: false,
 white: true
 */
 /*global $: true */

 window.spa.shell.nav = (function () {
    'use strict';

    const
    configMap = {
        settable_map: {
            activeClass: true
        },
        activeClass: 'active'
    },
    stateMap = {
     $append_target: null,
     current_menu_state: 'closed'
 };

 let
 jqueryMap = {};

    //Utility Methods
    const _toggleMenuButton = function (new_state) {
        switch (new_state) {
            case 'open':
            jqueryMap.$hamburger.addClass(configMap.activeClass);
            jqueryMap.$menuContainer.slideDown('fast');
            break;
            case 'closed':
            jqueryMap.$hamburger.removeClass(configMap.activeClass);
            jqueryMap.$menuContainer.slideUp('fast');
            break;
            default:
            jqueryMap.$hamburger.toggleClass(configMap.activeClass);
            jqueryMap.$menuContainer.slideToggle('fast');
            break;
        }
    };

    //DOM Methods
    const _setJqueryMap = function () {
        const $append_target = stateMap.$append_target

        jqueryMap = {
            $hamburger: $append_target.find('.hamburger'),
            $menuContainer: $append_target.find('.menu-container'),
        };
    };

    const _initEvents = function() {
        window.spa.util.uriAnchor.registerFunction('menu', _menuHandler);

        $(document).keydown(function (e) {
            // ESCAPE key pressed
            if (e.keyCode === 27) {
                window.spa.util.uriAnchor.changeAnchorPart({'menu': 'closed', 'search': 'closed'});
            }
        });

        jqueryMap.$hamburger.click(function() {
            window.spa.util.uriAnchor.changeAnchorPart({'menu': stateMap.current_menu_state === 'closed' ? 'open' : 'closed'});
        });

        $(window).on('onResize', function() {
            window.spa.util.uriAnchor.changeAnchorPart({'menu': 'closed'});
        });

        $(window).on('onScroll', function() {
            window.spa.util.uriAnchor.changeAnchorPart({'menu': 'closed'});
        });
    };

    //Event Handlers
    const _menuHandler = function (new_state) {
        stateMap.current_menu_state = new_state;
        _toggleMenuButton(stateMap.current_menu_state);

        return true;
    };

    //Public Methods 
    const configModule = function (input_map) {
        window.spa.util.setConfigMap({
            input_map: input_map,
            settable_map: configMap.settable_map,
            config_map: configMap
        });

        return true;
    };

    const initModule = function ($append_target) {
      stateMap.$append_target = $append_target;

      _setJqueryMap();
      _initEvents();

      return true;
  };

  return {
    initModule: initModule,
    configModule: configModule
};
}());